import { IconLib } from 'components/Atoms/IconLib'
import styled, { css } from 'styled-components'

const designerCSS = css`
  /*! CSS Used from: http://yolo.tino.me/wsb_dark/resources/css/modal.css */
  .popUpContainer {
    width: 100%;
    min-width: 300px;
    max-width: 600px;
    position: fixed;
    left: 50%;
    top: 50%
    -webkit-transition: top 0.5s ease;
    -moz-transition: top 0.5s ease;
    -o-transition: top 0.5s ease;
    transition: top 0.5s ease;
    transform: translate(-50%, -50%);
    -webkit-box-shadow: 0 0 100px rgba(0, 0, 0, 0.4);
    -moz-box-shadow: 0 0 100px rgba(0, 0, 0, 0.4);
    box-shadow: 0 0 100px rgba(0, 0, 0, 0.4);
    border-radius: 10px;
    z-index: 99;
  }
  article {
    max-height: 800px;
    height: fit-content;
    background-color: hsla(214, 18%, 16%, 0.8);
    backdrop-filter: blur(10px);
    border-radius: 0 0 10px 10px;
    padding: 0 30px 30px 0;
    display: flex;
    flex-direction: column;
  }
  h1 {
    font-size: 1.4rem;
    font-weight: 600;
    padding: 30px 0 0 30px;
  }
  h2 {
    font-size: 0.8rem;
    padding: 5px 0 0 30px;
    width: 300px;
    line-height: 120%;
  }


  /*! CSS Used from: http://yolo.tino.me/wsb_dark/resources/css/signin.css */
  .signin_modal_tabs_wrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    padding: 0 0 0 30px;
  }
  .signin_modal_tabs_wrapper .tabs {
    display: none;
  }
  .signin_modal_tabs_wrapper .tab {
    cursor: pointer;
    padding: 10px 20px;
    margin: 0 2px;
    background: transparent;
    border-bottom: 0;
    display: inline-block;
    border-radius: 10px;
    color: rgba(255, 255, 255, 0.5);
    font-size: 0.9rem;
  }
  .signin_modal_tabs_wrapper .panels {
    width: 100%;
    overflow: hidden;
    margin: 15px 0 0 0;
  }
  .signin_modal_tabs_wrapper .panel {
    display: none;
    animation: fadein 0.8s;
    width: 100%;
    padding: 0;
    background: transparent;
    flex-flow: row;
  }
  .signin_modal_tabs_wrapper .radio {
    display: none;
  }
  .signin_modal_tabs_wrapper #signin_one:checked ~ .panels #signin_one-panel,
  .signin_modal_tabs_wrapper #signin_two:checked ~ .panels #signin_two-panel {
    display: flex;
    align-items: flex-start;
  }
  .signin_modal_tabs_wrapper #signin_one:checked ~ .tabs #signin_one-tab,
  .signin_modal_tabs_wrapper #signin_two:checked ~ .tabs #signin_two-tab {
    background: var(--bidding-table-tab-selected-background);
    font-weight: 600;
    margin-left: -1px;
    color: #b3cbff;
    text-shadow: 0 0 10px var(--primary-shadow);
  }
  .signin_wrapper {
    flex-flow: column;
    display: flex;
    margin: 0 10px 0 0;
    padding: 0 400px 0 0;
  }
  .signin_wrapper * {
    display: flex;
  }
  .signin_wrapper form {
    flex-flow: column;
  }


  .signin_wrapper form fieldset {
    flex-flow: column;
    border: 0;
    min-width: 300px;
    margin: 15px 0 0 0;
  }
  .signin_wrapper form fieldset label {
    padding: 0 0 6px 0;
  }
  .signin_wrapper form label {
    font-weight: 600;
    font-size: 0.9rem;
    display: flex;
    margin: 0;
  }
  .signin_wrapper .forgot_password {
    margin: 5px 0 0 0;
    font-size: 0.75rem;
  }
  .signin_wrapper .forgot_password:hover {
    cursor: pointer;
  }
  .signin_wrapper form input[type='text'],
  .signin_wrapper form input[type='password'] {
    padding: 12px 15px;
    border-radius: 10px;
    font-size: 0.9rem;
    width: 100%;
    color: #000;
    line-height: 100%;
    outline: 0;
    border: 1px solid #fff;
    position: relative;
    z-index: 0;
  }
  .signin_wrapper form input[type='text']:focus,
  .signin_wrapper form input[type='password']:focus {
    border: 1px solid var( --primary-button-border);
    outline: 0;
    -webkit-box-shadow: 0 0 20px 0 var(--primary-shadow);
  }
  .signin_wrapper label .required_ast {
    color: #de0e54;
    font-size: 1rem;
    padding: 0 0 0 0.3em;
  }
  .signin_wrapper form .field_error {
    color: #de0e54;
    margin: 5px 0 0 0;
    font-size: 0.8rem;
  }
  .signin_wrapper form button {
    width: 100%;
    padding: 14px;
    font-size: 0.9rem;
    margin: 10px 0 0 0;
  }
  .signin_marketing_panel {
    background: hsla(0, 0%, 0%, 0.2)
      url('http://yolo.tino.me/wsb_dark/resources/images/signin_bg.jpg') center
      center / auto auto no-repeat;
    background-position: -90px -250px;
    height: 100%;
    width: 240px;
    position: absolute;
    right: 0;
    top: 0;
    border-radius: 0 10px 10px 0;
    display: flex;
    align-items: center;
    flex-flow: column;
    justify-content: space-between;
    padding: 30px;
  }
  .signin_marketing_panel .access_statement {
    font-size: 0.65rem;
    text-align: center;
    line-height: 120%;
  }
  .signin_marketing_panel .client_logo {
    display: flex;
    justify-content: center;
  }
  .signin_marketing_panel .client_logo.wallstreetbets {
    width: 90%;
    height: 100%;
    background: var(--main-logo) center center / contain no-repeat;
  }
 
  .signin_marketing_panel .user_alternate_access {
    display: flex;
    text-align: center;
    flex-direction: column;
    margin: 30px 0;
  }
  .signin_marketing_panel .user_alternate_access span {
    font-size: 0.8rem;
  }
  .signin_marketing_panel .user_alternate_access button {
    padding: 10px 15px;
    font-size: 0.9rem;
    font-weight: 600;
    margin: 10px 0 0 0;
  }
  /*! CSS Used from: http://yolo.tino.me/wsb_dark/resources/css/share-card.css */
  @media (max-width: 1200px) {
    a.closePopUp {
      left: 25px;
    }
  }
  @media (max-width: 600px) {
    article {
      height: fit-content !important;
    }
  }
  /*! CSS Used from: http://yolo.tino.me/wsb_dark/resources/css/dashboard.css */
  .radio {
    display: none;
  }
  .tabs {
    display: flex;
    flex-flow: row;
  }
  /*! CSS Used from: http://yolo.tino.me/wsb_dark/resources/css/wallet.css */
  .radio {
    display: none;
  }
  /*! CSS Used from: http://yolo.tino.me/wsb_dark/resources/css/res.css */
  @media (max-width: 600px) {
    article {
      height: 80vh;
      max-height: 80vh;
      overflow: auto;
      flex-direction: column;
    }
  }

  article {
    background: var(--overlay-pad-background);
    backdrop-filter: blur(25px);
  }


  .user-signin article,
  .user-register article {
    padding-bottom: 30px;
  }
  .signin_wrapper .user_alternate_access.mobile {
    display: none;
  }

  @media (max-width: 600px) {
    .signin_wrapper {
      padding: 0;
      margin: 0;
    }
    .signin_marketing_panel {
      display: none;
    }
    .popUpContainer.user-register,
    .popUpContainer.user-signin {
      max-width: 360px;
    }
    .user-signin article,
    .user-register article {
      padding-bottom: 30px;
      overflow: visible;
      height: fit-content;
      border-radius: 10px;
    }
    .signin_wrapper .user_alternate_access.mobile {
      display: flex;
      text-align: left;
      flex-direction: row;
      margin: 15px 0 0 0;
      padding: 15px 0 0 0;
      justify-content: flex-start;
      align-items: center;
      border-top: 1px solid hsla(0, 0%, 100%, 0.15);
    }
    .signin_wrapper .user_alternate_access.mobile span {
      font-size: 0.8rem;
    }
    .signin_wrapper .user_alternate_access.mobile button {
      padding: 8px 12px;
      font-size: 0.75rem;
      font-weight: 600;
      width: fit-content;
      margin: 0 0 0 15px;
    }
  }

`

const forgotPswPanelCSS = css`
  /*! CSS Used from: http://yolo.tino.me/game/resources/css/wallet_menu.css */
  /* .signin_modal_tabs_wrapper .panel {
    display: flex;
    animation: fadein 0.8s;
    width: 100%;
    padding: 0;
    background: transparent;
    flex-flow: row;
  } */

  .signin_modal_tabs_wrapper #hidden_pr:checked ~ .panels #hidden_pr-panel {
    display: flex;
    align-items: flex-start;
  }
  .password_reset_content {
    flex-flow: column;
    display: flex;
    margin: 0 10px 0 0;
    padding: 0 200px 0 0;
    width: 400px;
    width: 100%;
  }
  .password_reset_content * {
    display: flex;
  }
  .password_reset_content form {
    flex-flow: column;
  }
  .password_reset_content .section_title {
    padding: 0 0 10px 0;
    color: rgba(255, 255, 255, 1);
    font-size: 1.2rem;
    font-weight: 600;
    display: flex;
  }
  .password_reset_content .page_instructions,
  .password_reset_content .page_instructions div {
    display: inline-block;
    font-size: 0.75rem;
  }
  .password_reset_content .page_instructions div {
    padding: 5px 0;
  }
  .password_reset_content .page_instructions span {
    display: inline-block;
    text-decoration: underline;
  }

  .password_reset_content .page_instructions span:hover {
    display: inline-block;
    cursor: pointer;
    text-decoration: none;
  }
  fieldset.digit_6_confirmation {
    width: fit-content;
    min-width: 310px;
    background: var(--chat-message-pad-background);
    padding: 25px;
    border-radius: 10px;
    outline: 0;
    border: 0;
    margin: 15px 0;
    flex-flow: column;
    justify-content: center;
  }
  fieldset.digit_6_confirmation div {
    justify-content: space-between;
  }
  fieldset.digit_6_confirmation input[type='text'] {
    font-size: 1.6rem;
    font-weight: 500;
    color: #000;
    padding: 10px;
    width: 40px;
    line-height: 100%;
    text-align: center;
    border-radius: 10px;
  }
  .error_banner {
    width: 100%;
    font-size: 0.8rem;
    color: #de0e54;
    margin: 0;
    line-height: 100%;
  }
  form.new_password {
    margin: 0px 0 0 0;
  }
  form.new_password fieldset {
    flex-flow: column;
    border: 0;
    width: fit-content;
    margin: 15px 0 0 0;
  }
  form.new_password fieldset label {
    padding: 0 0 6px 0;
    font-weight: 600;
    display: flex;
    margin: 0;
  }

  form.new_password fieldset .required label {
    padding: 0;
  }

  form.new_password fieldset .forgot_password {
    margin: 5px 0 0 0;
    font-size: 0.75rem;
  }

  form.new_password fieldset input[type='text'],
  form.new_password fieldset input[type='password'] {
    padding: 12px 15px;
    border-radius: 10px;
    font-size: 0.9rem;
    width: 100%;
    color: #000;
    line-height: 100%;
    outline: 0;
    border: 1px solid #fff;
    position: relative;
    z-index: 0;
    max-width: 400px;
    min-width: 310px;
  }
  form.new_password fieldset input[type='text']:focus,
  form.new_password fieldset input[type='password']:focus {
    border: 1px solid var(--primary-button-border);
    outline: 0;
    -webkit-box-shadow: 0 0 20px 0 var(--primary-shadow);
  }
  form.new_password fieldset label .required_ast {
    color: #de0e54;
    font-size: 1rem;
    line-height: 150%;
    padding: 0 0 0 0.3em;
  }
  form.new_password .field_error {
    color: #de0e54;
    margin: 5px 0 0 0;
    font-size: 0.8rem;
  }
  form.new_password fieldset button {
    background: var(--primary-button-background);
    border-radius: 10px;
    width: 100%;
    padding: 14px;
    font-size: 0.9rem;
    margin: 10px 0 0 0;
    line-height: 100%;
  }
  form.new_password fieldset button:hover {
    background: var(--primary-button-hover-background);
  }
  form.new_password .return_to_signin {
    display: block;
    margin: 10px 0 0 0;
    font-size: 0.83rem;
  }

  form.new_password .return_to_signin:hover {
    cursor: pointer;
  }

  @media (max-width: 480px) {
    fieldset.digit_6_confirmation {
      min-width: 320px;
    }
    fieldset.digit_6_confirmation input[type='number'] {
      font-size: 1.4rem;
      font-weight: 500;
      color: #000;
      padding: 10px;
      width: 40px;
    }
    form.new_password fieldset input[type='text'] {
      min-width: 320px;
    }
  }
`

const developerCSS = css``

export const SignInModalCSS = styled.div`
  ${designerCSS}
  ${forgotPswPanelCSS}
  ${developerCSS}
`
export const Close = styled(IconLib).attrs((props) => ({
  collection: 'general',
  name: 'closeOutline',
  dimension: '25px',
}))`
  color: #fff;
  font-size: 1.4rem;
  line-height: 100%;
  position: absolute;
  border-radius: 50%;
  width: 25px;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  left: -8px;
  text-align: center;
  text-decoration: none;
  top: -8px;
  z-index: 1;
  background: rgba(255, 255, 255, 1);

  @media (max-width: 480px) {
    left: -8px;
    top: -8px;
  }
`
